import {persistStore, persistReducer} from 'redux-persist';
import AsyncStorage from '@react-native-async-storage/async-storage';
import rootReducer from '../Reducers';
import {configureStore as ReduxStore} from '@reduxjs/toolkit';

/**
 *
 * @returns
 */
const configureStore = () => {
  const persistConfig = {
    key: 'root',
    storage: AsyncStorage,
    whitelist: ['appPreservedConfigSlice', 'deviceConfigSlice', 'hotelLangSlice', 'serverDateTimeSlice', 'guestDetailsSlice', 'hotelSelectorSlice', 'dynamicStyleSlice', 'countryListtSlice', 'documentListSlice', 'notificationSlice', 'translationSlice' ],
    // Throttle persist writes to reduce storage operations
    throttle: 1000,
  };

  const persistedReducer = persistReducer(persistConfig, rootReducer);

  const store = ReduxStore({
    reducer: persistedReducer,
    middleware: getDefaultMiddleware =>
      getDefaultMiddleware({
        serializableCheck: false,
        // Disable immutability checks in production for better performance
        immutableCheck: process.env.NODE_ENV !== 'production',
      }),
  });

  let persistor = persistStore(store);

  return {store, persistor};
};
export default configureStore;
